// extracted by mini-css-extract-plugin
module.exports = {"imgWrap":"index_imgWrap__kQA6o","product-video-Montmorillonite":"index_product-video-Montmorillonite__zeL0c"};